import {
  getRatingsFromSurveyScale,
  type MatrixQuestionInsights,
} from "@repo/app-types/client/client";
import type { FC } from "react";
import { InsightsTable, type InsightsTableRowData } from "./insightsTable.js";
import { InsightsCard } from "./keywordTracker/keywordTrackerCardContainer.js";

interface MatrixSummaryCardProps {
  summary: MatrixQuestionInsights;
}

export const MatrixSummaryCard: FC<MatrixSummaryCardProps> = ({ summary }) => {
  const { question, scale, response_count, data } = summary;

  if (!scale) return null;

  const ratingScaleMembers = getRatingsFromSurveyScale(scale);
  const columnNames = ratingScaleMembers.map((r) => r.name);

  const rowData: InsightsTableRowData[] = data.map((vector) => {
    const columns = ratingScaleMembers.map((member) => {
      const count = vector.ratings[member.rating] ?? 0;
      const percentage = count > 0 ? (count / response_count) * 100 : 0;
      return { percentage, width: "14%" };
    });

    return {
      value: vector.name,
      columns,
    };
  });

  return (
    <InsightsCard
      header={
        <div className="flex min-h-[28px] flex-row items-center space-x-1 text-base font-semibold text-foreground">
          {question}
          {` (${summary.response_count} ${
            summary.response_count > 1 ? "responses" : "response"
          })`}
        </div>
      }
      body={<InsightsTable rowData={rowData} headerColumns={columnNames} />}
    />
  );
};
